import classNames from "classnames";
import React, { useCallback } from "react";

import {
    IReviewsProductTypeID,
    isoReviewsProductTypeID,
} from "../../../models/nominals";
import {
    IReviewQueryFacets,
    ISearchFacetOption,
} from "../../../models/reviews.interfaces";
import { useAppSelector, useDispatchers } from "../../reducers";
import { defaultState } from "../defaults";
import { Dispatchers } from "../dispatchers";
import { FilterOptionCollection } from "./FilterOptionCollection";

import styles from "./ProductTypeFilter.module.scss";

export interface IFacetCollection {
    name: string | null;
    options: ISearchFacetOption[];
}

interface IProps {
    facetType: IReviewQueryFacets;
    productTypeID: IReviewsProductTypeID;
    name: string;
    collections: IFacetCollection[];
    isCarouselComponentType: boolean;
    isCollapsedView?: boolean;
    isCondensedView?: boolean;
}

export const ProductTypeFilter = (props: IProps): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    const isOpen = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.productTypeIDs.includes(props.productTypeID);
    });

    const handleChange = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            dispatchers.updateProductTypes(
                props.productTypeID,
                e.currentTarget.checked,
            );
        },
        [dispatchers, props.productTypeID],
    );

    const parentClasses = classNames({
        [styles.filterTitle]: true,
        [styles.filterTitleParent]: true,
        [styles.filterTitleParentOpen]: isOpen,
        [styles.filterTitleCollapsed]: props.isCollapsedView,
        "customer-review__side-filters__filter-title--collapsed":
            props.isCollapsedView,
    });
    const inputID = `product-type-${props.productTypeID}`.toLowerCase();

    return (
        <div>
            {!props.isCarouselComponentType && (
                <h3 className={parentClasses}>
                    {!props.isCollapsedView && (
                        <input
                            id={inputID}
                            type="checkbox"
                            className={styles.checkbox}
                            value={isoReviewsProductTypeID.unwrap(
                                props.productTypeID,
                            )}
                            checked={isOpen}
                            onChange={handleChange}
                        />
                    )}
                    <label htmlFor={inputID}>{props.name}</label>
                </h3>
            )}
            {props.collections.map((collection, i) => (
                <FilterOptionCollection
                    key={i}
                    facetType={props.facetType}
                    name={collection.name}
                    options={collection.options}
                    isOpen={isOpen}
                    isCarouselComponentType={props.isCarouselComponentType}
                    isCollapsedView={props.isCollapsedView}
                    isCondensedView={props.isCondensedView}
                />
            ))}
        </div>
    );
};
